<template>
  <section>
    <div class="container-fluid">
      <div class="blur">
        <div class="white-bgg"></div>
        <div
          class="img-bgg"
          v-bind:style="{
            'background-image':
              'url(https://pic.imamhussain.org/photos/preview/' +
              $route.query.image,
          }"
        ></div>
      </div>
      <div class="row">
        <div class="col-md-1 layer"></div>
        <div class="col-md-10 layer">
          <div class="row justify-content-center">
            <div class="v-h"></div>
            <div class="col-md-12 dd-h"></div>

            <div class="col-md-8">
              <div
                class="day-pic d-flex justify-content-center align-items-center"
                v-if="$route.query.image"
              >
                <div v-if="$route.query.pres != 0 && $route.query.pres < 60">
                  <img
                    :src="
                      'https://pic.imamhussain.org/photos/hd/' +
                      $route.query.image
                    "
                    class="day-pic-img"
                    :width="details.width * details.height"
                    :alt="details.name"
                  />
                  <br/>
                </div>
                <div v-else>
                  <img
                    v-if="
                      Number($route.query.width) > Number($route.query.height)
                    "
                    :src="
                      'https://pic.imamhussain.org/photos/hd/' +
                      $route.query.image
                    "
                    class="day-pic-img"
                    :width="
                      $route.query.width < 250
                        ? $route.query.width * 4
                        : $route.query.width
                    "
                    :alt="details.name"
                  />
                  <img
                    v-if="
                      Number($route.query.width) < Number($route.query.height)
                    "
                    :src="
                      'https://pic.imamhussain.org/photos/hd/' +
                      $route.query.image
                    "
                    class="day-pic-img"
                    :height="$route.query.height"
                    :alt="details.name"
                  />
                  <img
                    v-if="
                      Number($route.query.width) == Number($route.query.height)
                    "
                    :src="
                      'https://pic.imamhussain.org/photos/hd/' +
                      $route.query.image
                    "
                    class="day-pic-img"
                    :height="$route.query.height"
                    :alt="details.name"
                  />
                </div>
              </div>
              <div
                class="day-pic d-flex justify-content-center align-items-center"
                v-else
              >
                <div v-if="$route.query.pres != 0 && $route.query.pres < 60">
                  <img
                    :src="
                      'https://pic.imamhussain.org/photos/hd/' +
                      $route.query.image
                    "
                    class="day-pic-img"
                    :width="details.width * details.height"
                    :alt="details.name"
                  />
                  <br /><br /><br />
                </div>
                <div v-else>
                  <img
                    v-if="Number(details.width) > Number(details.height)"
                    :src="
                      'https://pic.imamhussain.org/photos/hd/' + details.file
                    "
                    class="day-pic-img"
                    :width="
                      details.width < 250 ? details.width * 4 : details.width
                    "
                    :alt="details.name"
                  />
                  <img
                    v-if="Number(details.width) < Number(details.height)"
                    :src="
                      'https://pic.imamhussain.org/photos/hd/' + details.file
                    "
                    class="day-pic-img"
                    :height="details.height"
                    :alt="details.name"
                  />
                  <img
                    v-if="Number(details.width) == Number(details.height)"
                    :src="
                      'https://pic.imamhussain.org/photos/hd/' + details.file
                    "
                    class="day-pic-img"
                    :height="details.height"
                    :alt="details.name"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-1 layer"></div>
      </div>
    </div>
    <div class="container">
      <div class="row mb-5">
        <div class="col-md-12">
          <div class="d-flex justify-content-center mt-3">
        <vs-button
          v-if="nextPhoto"
          border
          danger
          :to="{
            name: 'details',
            params: { id: nextPhoto.id },
            query: {
              image: nextPhoto.image,
              height: nextPhoto.height,
              width: nextPhoto.width,
              pres: (nextPhoto.height / nextPhoto.width) * 100,
            },
          }"
        >
          <ion-icon name="arrow-forward-outline"></ion-icon>
          <span style="color: #ffffff82"
            ><b> التـالـي  </b></span
          >
        </vs-button>
        <vs-button
          v-if="nextPhoto"
          border
          color="white"
          danger
          :to="{
            name: 'details',
            params: { id: prevPhoto.id },
            query: {
              image: prevPhoto.image,
              height: prevPhoto.height,
              width: prevPhoto.width,
              pres: (prevPhoto.height / prevPhoto.width) * 100,
            },
          }"
        >
          <span style="color: #ffffff82"
            ><b> السابق  </b></span
          >
          <ion-icon name="arrow-back-outline"></ion-icon>
        </vs-button>
          </div>
        </div>
        <div class="col-md-8">
          <router-link
            :to="{ name: 'profile', params: { id: details.user.id } }"
            href="#"
            class="user d-flex align-items-center my-2"
          >
            <img
              v-if="details.user.avatar != null"
              :src="`https://pic.imamhussain.org/avatars/medium/${details.user.avatar}`"
              :alt="details.user.name"
              style="object-fit: cover"
            />
            <img
              v-else
              :src="`https://ui-avatars.com/api/?name=${details.user.name}&length=1&bold=true`"
              :alt="details.user.name"
              style="object-fit: cover"
            />
            <h6 class="mx-3 text-dark">{{ details.user.name }}</h6>
          </router-link>
          <div class="d-flex align-items-center my-2 flex-wrap">
            <ion-icon
                name="text-outline"
                class="text-warning mx-2"
                style="font-size: 16px"
              ></ion-icon>
            <span class="font-weight-bold my-2">عنوان الصورة : </span>
            <h6 class="text-dark mx-2 my-2 n-lab">
            {{ details.name }}
          </h6>
          </div>
          <div class="d-flex align-items-center">
            <ion-icon
                name="calendar-outline"
                class="text-warning mx-2"
                style="font-size: 16px"
              ></ion-icon>
            <span class="font-weight-bold">تاريخ النشر  : </span>
            <h6 class="text-dark mx-2 mb-0">
              
              <span class="text-dark mx-1" style="font-size: 16px">{{
                moment(details.created_at).format("DD-MM-YYYY")
              }}</span>
          </h6>
          </div>
          <div class="d-flex align-items-center my-2">
            <ion-icon
                name="folder-outline"
                class="text-warning mx-2"
                style="font-size: 16px"
              ></ion-icon>
            <span class="font-weight-bold my-2">القسم   : </span>
            <router-link v-if="details.category"
              :to="{
                name: 'category',
                params: { link: details.category.link },
              }"
              class="d-flex align-items-center"
               
            >
              
              <span v-if="details.category"
                style="font-size: 16px"
                class=" text-dark mx-2"
              >
                {{ details.category.name }}</span
              >
            </router-link>

          </div>
          <div class="d-flex align-items-center flex-wrap ">
            <ion-icon
                name="at-outline"
                class="text-warning mx-2"
                style="font-size: 16px"
              ></ion-icon>
            <span class="font-weight-bold">الكلمات المفتاحية   : </span>
            <div class="n-lay mx-2" v-if="details.tags != null">
          <a
            href="#"
            class="font-weight-bold text-danger mx-1"
            v-for="tag in details.tags"
            :key="tag"
            @click="showtag(tag)"
            >#{{ tag.value }}</a
          >
        </div>
        <vs-dialog scroll overflow-hidden width="80vw" v-model="search">
          <template #header>
            <h4 class="not-margin">بحث <b>في المكتبة الصورية</b></h4>
          </template>

          <Search :q="q" @close="search = false" />
        </vs-dialog>

          </div>
          <!-- <div class="d-flex align-items-center my-2">
            <ion-icon
                name="camera-outline"
                class="text-warning mx-2"
                style="font-size: 16px"
              ></ion-icon>
            <span class="font-weight-bold my-2"> معلومات الكامرة : </span>
            <h6 class="text-dark mx-2 mb-0">
            {{ details.info.Model }}
          </h6>
          </div>
          <div class="d-flex align-items-center">
            <ion-icon
                name="aperture-outline"
                class="text-warning mx-2"
                style="font-size: 16px"
              ></ion-icon>
            <span class="font-weight-bold"> نوع العدسة : </span>
            <h6 class="text-dark mx-2 mb-0">
            {{ details.info.lens }}
          </h6>
          </div> -->
        </div>
        <div class="col-md-4">
          <div class="d-flex flex-column align-items-center">
            <div class="n-lay col-md-2 my-2">
          <div class="d-flex icons mt-3">
            <div class="mx-2" @click="likePhoto(details)">
              <i
                class="fa-solid fa-thumbs-up fa-2xl"
                :class="{ 'text-danger': liked }"
              ></i>
              <div class="h6 font-weight-bold text-secondary mx-2 mt-2">
                {{ details.likes }}
              </div>
              <!-- <font-awesome-icon icon="fa-solid fa-thumbs-up" /> -->
            </div>
            <!-- Button trigger modal -->

            <!-- Modal -->
            <div
              class="modal fade"
              id="share"
              tabindex="4"
              role="dialog"
              aria-labelledby="exampleModalCenterTitle"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h6
                      class="modal-title font-weight-bold"
                      id="exampleModalLongTitle"
                    >
                      مشاركة الصورة في التواصل الاجتماعي
                    </h6>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body">
                    <div class="content">
                      <ul class="list-unstyled m-0">
                        <li class="p-3 shear-border m-0">
                          <a
                            :href="`https://www.facebook.com/sharer/sharer.php?u=https://pic.imamhussain.org/${$route.path}`"
                            class="text-dark"
                          >
                            <img
                              src="@/assets/img/facebook.png"
                              alt="facebook share"
                              height="32px"
                            />
                            مشاركة على فيسبوك
                          </a>
                        </li>
                        <li class="p-3 shear-border m-0">
                          <a
                            :href="`whatsapp://send?text=${details.name} https://pic.imamhussain.org${$route.path}`"
                            class="text-dark"
                          >
                            <img
                              src="@/assets/img/whatsapp.png"
                              alt="facebook share"
                              height="32px"
                            />
                            مشاركة على واتس اب
                          </a>
                        </li>

                        <li class="p-3 shear-border m-0">
                          <a
                            :href="`https://telegram.me/share/url?url=https://pic.imamhussain.org/${$route.path} ${details.name}`"
                            class="text-dark"
                          >
                            <img
                              src="@/assets/img/telegram.png"
                              alt="telegram share"
                              height="32px"
                            />
                            مشاركة على تليجرام
                          </a>
                        </li>
                        <li class="p-3 shear-border m-0 align-items-center d-flex">
                          <a
                            :href="`https://twitter.com/intent/tweet?text=https://pic.imamhussain.org/${$route.path} ${details.name}`"
                            class="text-dark"
                          >
                            <img
                              src="@/assets/img/twitter.png"
                              alt="twitter share"
                              height="32px"
                            />
                            مشاركة على تويتر
                          </a>
                        </li>
                        <li class="p-3 shear-border m-0" @click="copyText">
                          <ion-icon name="copy-outline"></ion-icon>
                          نسخ رابط
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="mx-2">
              <i
                class="fa-solid fa-share-nodes fa-xl"
                data-toggle="modal"
                data-target="#share"
              ></i>
            </div>
            <div class="mx-2">
              <i class="fa-solid fa-eye fa-xl"></i>
              <div class="h6 font-weight-bold text-secondary mx-2 mt-2">
                {{ details.views }}
              </div>
              <!-- <font-awesome-icon icon="fa-light fa-flag" /> -->
            </div>
          </div>
        </div>
        <div class="">
            <div v-if="$darkmode">
              <qrcode-vue
                :value="`https://pic.imamhussain.org/index.php/photo/download/${details.file}`"
                :size="100"
                level="L"
                background="black"
                foreground="white"
              />
            </div>
            <div v-if="!$darkmode">
              <qrcode-vue
                :value="`https://pic.imamhussain.org/index.php/photo/download/${details.file}`"
                :size="100"
                level="L"
              />
            </div>
          </div>
          <div class="btn-group rounded my-2" role="group">
              <button id="btnGroupDrop1" type="button" class="btn cursor btn-light" data-toggle="dropdown"
                aria-expanded="false">
                تحميل الصورة
                <img src="@/assets/down.svg" alt="download" height="20" class="mr-2 mb">
              </button>
              <div class="dropdown-menu" aria-labelledby="btnGroupDrop1">
                <a class="dropdown-item text-right"
                  :href="`https://pic.imamhussain.org/index.php/photo/download/hd/${$route.query.image}`">تحميل بدقة
                  عالية</a>
                <a class="dropdown-item text-right"
                  :href="`https://pic.imamhussain.org/index.php/photo/download/${$route.query.image}`">تحميل بالحجم
                  الكامل</a>
              </div>
            </div>
        </div>
          </div>
      </div>
      <hr style="border-top:1px solid rgb(116 116 116 / 25%);">

      <div class="row align-items-center justify-content-around">
        <div class="d-flex mx-2 my-2">
          <ion-icon name="phone-portrait-outline" class="text-warning mx-2"></ion-icon>
        <h6 class="my-1">لتحميل تطبيق معرض الصور</h6>
        </div>
        <div class="d-flex cu-app">
          <a href="https://play.google.com/store/apps/details?id=com.imamhussain.photo&hl=ar&gl" class="mx-2">
              <img src="@/assets/img/google.png" alt="google play">
          </a>
          <a href="https://apps.apple.com/sa/app/%D9%85%D8%B9%D8%B1%D8%B6-%D8%A7%D9%84%D8%B5%D9%88%D8%B1/id6477335792" class="mx-2">
            <img src="@/assets/img/apple.png" alt="app store">
          </a>
        </div>
      </div>
      <hr style="border-top:1px solid rgb(116 116 116 / 25%);">
    </div>
    
    
    


    <CategoryDialog v-if="details.category" :category_id="details.category.id"></CategoryDialog>
    
  </section>
</template>
<script>

import Search from "../views/Search.vue";
import QrcodeVue from "qrcode.vue";
import moment from "moment";
import CategoryDialog from "@/components/CategoryDialog.vue";
export default {
  components: {
    CategoryDialog,
    Search,
    QrcodeVue,
  },
  filters: {
    bytesForHuman(bytes) {
      let units = ["B", "KB", "MB", "GB", "TB", "PB"];

      let i = 0;

      for (i; bytes > 1024; i++) {
        bytes /= 1024;
      }

      return bytes.toFixed(1) + " " + units[i];
    },
  },

  metaInfo() {
    return {
      title: this.$store.state.title ?? "hh",
      meta: [
        {
          vmid: "description",
          name: "description",
          hhh: "description",
          content: this.$store.state.description,
        },
        {
          itemprop: "image",
          content:
            "https://pic.imamhussain.org/photos/preview/" +
            this.$store.state.file,
        },
        {
          name: "twitter:image:src",
          content:
            "https://pic.imamhussain.org/photos/preview/" +
            this.$store.state.file,
        },
        {
          property: "og:image",
          content:
            "https://pic.imamhussain.org/photos/preview/" +
            this.$store.state.file,
        },
      ],
    };
  },
  name: "detailsPage",
  beforeMount() {
    this.$store.state.title = "";
    this.$store.state.description = "";
    this.$store.state.file = "";
  },
  watch: {
    $route() {
      setTimeout(() => {
        this.fetchDetails();
      }, 100);
    },
  },
  data() {
    return {
      title: "ggg",
      search: false,
      q: null,
      moment: moment,
      liked: false,
      details: [
        {
          name: "test",
        },
      ],
      loading: false,
      category: [],
      cat_id: 0,
        
    };
  },
  computed: {
    nextPhoto() {
      if (
        this.$store.state.gallery.all.length != 0 &&
        this.details.length != 0
      ) {
        var vm = this;
        var i = 0;
        this.$store.state.gallery.all.data.filter(function (item, index) {
          if (item.id == vm.details.id) {
            i = index;
            return index;
          }
        });
        if (this.$store.state.gallery.all.data[Number(i) + 1] != undefined) {
          return this.$store.state.gallery.all.data[Number(i) + 1];
        } else {
          return this.$store.state.gallery.all.data[0];
        }
      } else {
        return 0;
      }
    },
    prevPhoto() {
      if (
        this.$store.state.gallery.all.length != 0 &&
        this.details.length != 0
      ) {
        var vm = this;
        var i = 0;
        this.$store.state.gallery.all.data.filter(function (item, index) {
          if (item.id == vm.details.id) {
            i = index;
            return index;
          }
        });
        if (this.$store.state.gallery.all.data[Number(i) - 1] != undefined) {
          return this.$store.state.gallery.all.data[Number(i) - 1];
        } else {
          return this.$store.state.gallery.all.data[
            this.$store.state.gallery.all.data.length - 1
          ];
        }
      } else {
        return 0;
      }
    },
  },
  created() {
    this.fetchDetails();

  },
  methods: {
    
    copyText() {
      navigator.clipboard.writeText(window.location.href);
      this.$vs.notification({
                progress: 'auto',
                color: 'success',
                position: 'bottom-left',
                title: '',
                text: `تم نسخ الرابط الى الحافظة`
              })
    },
    likePhoto(photo) {
      this.liked = !this.liked;
      const data = new FormData();
      data.append("post_id", photo.id);
      this.axios
        .post(`https://pic.imamhussain.org/index.php/like`, data)
        .then((res) => {
          if (res.status == 200) {
            this.liked = true;
          }
        });
    },
    fetchDetails() {
      this.loading = true;
      this.axios
        .get(
          "https://pic.imamhussain.org/index.php/photos/" +
            this.$route.params.id
        )
        .then((res) => {
          res = res.data;
          this.liked = res.liked;
          this.details = res;
          this.$store.state.title = res.name;
          this.$store.state.description = res.description;
          this.$store.state.file = res.file;
          this.loading = false;
          try {
            var dimensions = res.dimensions.split("x");
            var width = Number(dimensions[0]);
            var height = Number(dimensions[1]);
          } catch (error) {
             dimensions = res.dimensions;
             width = Number(dimensions[0]);
             height = Number(dimensions[1]); 
            }
          var orientation = "h";
          var pres = 0;
          if (width > height) {
            orientation = "h";
            pres = (height / width) * 100;
          }

          if (width < height) {
            orientation = "v";
          }
          this.details.orientation = orientation;
          this.details.width = width;
          this.details.pres = pres;
          this.details.height = height;
          
        });
    },
    showtag(tag) {
      this.search = !this.search;
      this.q = tag.value;
    },
  },
};
</script>
<style lang="scss" scoped>
.user img {
  height: 48px;
  width: 48px;
  border-radius: 50%;
  border: 2px solid #ccc;
}

.cu-app > a > img {
  height: 60px;
  border: 1px solid #595959;
  border-radius: 8px;
}

@media (min-width: 320px) and (max-width: 767px) {
  .cu-app {
    flex-direction: column;
  }
}

.cu-app > a  {
  margin:4px auto ;
}
</style>